
import { Link } from 'react-router-dom';

export default function Countries() {
  const countries = [
    {
      name: 'Chile',
      flag: '🇨🇱',
      description: 'Operaciones reguladas por la Comisión para el Mercado Financiero (CMF)',
      phone: '+56 2 2345 6789',
      email: 'chile@novacreditos.com',
      offices: 'Santiago, Valparaíso, Concepción'
    },
    {
      name: 'Perú',
      flag: '🇵🇪',
      description: 'Supervisados por la Superintendencia de Banca, Seguros y AFP (SBS)',
      phone: '+51 1 234 5678',
      email: 'peru@novacreditos.com',
      offices: 'Lima, Arequipa, Trujillo'
    },
    {
      name: 'México',
      flag: '🇲🇽',
      description: 'Regulados por la Comisión Nacional Bancaria y de Valores (CNBV)',
      phone: '+52 55 1234 5678',
      email: 'mexico@novacreditos.com',
      offices: 'Ciudad de México, Guadalajara, Monterrey'
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Presencia Internacional
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Operamos con respaldo institucional y cumplimiento normativo en tres países
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {countries.map((country, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow">
              <div className="text-6xl mb-4 text-center">{country.flag}</div>
              <h3 className="text-2xl font-bold text-slate-800 mb-3 text-center">{country.name}</h3>
              <p className="text-sm text-slate-600 mb-6 leading-relaxed">{country.description}</p>
              
              <div className="space-y-3 mb-6">
                <div className="flex items-start space-x-3">
                  <i className="ri-phone-fill text-emerald-600 mt-1"></i>
                  <div>
                    <p className="text-xs text-slate-500">Teléfono</p>
                    <p className="text-sm text-slate-700 font-medium">{country.phone}</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-mail-fill text-emerald-600 mt-1"></i>
                  <div>
                    <p className="text-xs text-slate-500">Email</p>
                    <p className="text-sm text-slate-700 font-medium">{country.email}</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-map-pin-fill text-emerald-600 mt-1"></i>
                  <div>
                    <p className="text-xs text-slate-500">Oficinas</p>
                    <p className="text-sm text-slate-700 font-medium">{country.offices}</p>
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-200">
                <div className="flex items-center justify-center space-x-2 text-emerald-600">
                  <i className="ri-shield-check-fill"></i>
                  <span className="text-xs font-medium">Regulación Financiera Activa</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/paises" className="inline-block px-8 py-4 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
            Conocer Más sobre Nuestras Operaciones
          </Link>
        </div>
      </div>
    </section>
  );
}
